(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tym-product-card-grid"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-tym-card-grid]').forEach((grid) => {
      const cards = [...grid.querySelectorAll('.tym-card[data-series-key]')];
      if (!cards.length) return;

      const filterCards = (seriesKey) => {
        if (!seriesKey) {
          cards.forEach((card) => card.classList.remove('is-hidden'));
          return;
        }
        let visibleCount = 0;
        cards.forEach((card) => {
          const match = card.dataset.seriesKey === seriesKey;
          card.classList.toggle('is-hidden', !match);
          if (match) visibleCount += 1;
        });
        if (visibleCount === 0) {
          cards.forEach((card) => card.classList.remove('is-hidden'));
        }
      };

      window.addEventListener('tym:series-change', (event) => {
        filterCards(event.detail?.seriesKey || '');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tym-product-series-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-tym-series]').forEach((root) => {
      const slides = [...root.querySelectorAll('[data-slide]')];
      if (!slides.length) return;
      let idx = slides.findIndex((s) => s.classList.contains('is-active'));
      if (idx < 0) idx = 0;

      const emitSeriesChange = () => {
        const active = slides[idx];
        const key = active?.dataset.seriesKey || '';
        window.dispatchEvent(new CustomEvent('tym:series-change', { detail: { seriesKey: key } }));
      };

      const show = (i) => {
        idx = (i + slides.length) % slides.length;
        slides.forEach((s, n) => s.classList.toggle('is-active', n === idx));
        emitSeriesChange();
      };

      root.querySelector('[data-prev]')?.addEventListener('click', () => show(idx - 1));
      root.querySelector('[data-next]')?.addEventListener('click', () => show(idx + 1));
      emitSeriesChange();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
